import classNames from 'classnames';
import React from 'react';

import {TRANSITION_DELAY_CLASSNAME, TRANSITION_DURATION_CLASSNAME} from '../StudentHomepage';
import SidebarContent from './SidebarContent';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional {
  pathname: string;
}

export default function SidebarDesktop({className, pathname}: Props) {
  const {isSidebarExpanded} = useStudentDashboard();

  return (
    <div
      aria-hidden={!isSidebarExpanded}
      className={classNames(className, 'relative hidden overflow-x-clip m:block')}
    >
      <div
        className={classNames(
          TRANSITION_DURATION_CLASSNAME,
          'absolute! z-10 flex h-full w-full flex-col gap-x3 px-x4 pt-x7 pb-x3 transition',
          {'opacity-0': !isSidebarExpanded, [TRANSITION_DELAY_CLASSNAME]: isSidebarExpanded}
        )}
      >
        <SidebarContent pathname={pathname} />
      </div>
    </div>
  );
}
